module.exports = __webpack_public_path__ + "合作9.png?ec0720248c062acf2f72128c280efa7a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作9.png
// module id = 651
// module chunks = 0